import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Calendar, User } from 'lucide-react';
import { blogArticles } from '../data/blogContent';
import SEO from '../components/SEO';
import PageHero from '../components/PageHero';

const Blog = () => {
  return (
    <div style={{ marginTop: '100px' }}>
      <SEO
        title="Blog Nutrition Hormonale & SOPK | Harmonie Féminine Vevey"
        description="Articles sur la nutrition hormonale, le SOPK, la perte de poids, la préménopause et l'équilibre émotionnel. Conseils du Nutri Centre Riviera — Vevey, Clarens, Montreux."
        keywords="blog nutrition femme, articles SOPK, conseils perte de poids hormonale, blog nutritionniste Vevey, préménopause Riviera"
        url="https://nutricentreriviera.ch/blog"
      />
      <PageHero
        image="/images/blog-hero.webp"
        alt="Carnet ouvert, tisane et feuilles de sauge sur lin crème — ambiance éditoriale du blog nutrition"
        title="Blog Nutrition & Santé Hormonale"
        subtitle="Conseils, astuces et informations pour comprendre et optimiser votre santé hormonale sur la Riviera"
      />

      <section className="section-lg" style={{ background: 'white' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
            gap: '3rem'
          }}>
            {blogArticles.map((article) => (
              <Link
                key={article.id}
                to={`/blog/${article.slug}`}
                style={{
                  textDecoration: 'none',
                  color: 'inherit',
                  display: 'block',
                  background: 'white',
                  borderRadius: '1rem',
                  overflow: 'hidden',
                  border: '1px solid var(--border-light)',
                  transition: 'all 0.3s ease'
                }}
                className="blog-card"
              >
                <div style={{
                  height: '200px',
                  overflow: 'hidden',
                  background: 'var(--bg-section)'
                }}>
                  <img
                    src={article.image}
                    alt={article.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      transition: 'transform 0.3s ease'
                    }}
                    className="blog-image"
          loading="lazy"
          decoding="async"/>
                </div>
                <div style={{ padding: '2rem' }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                    marginBottom: '1rem'
                  }}>
                    <span className="caption" style={{
                      background: 'var(--accent-primary-light)',
                      color: 'var(--accent-primary)',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '1rem'
                    }}>
                      {article.category}
                    </span>
                    <span className="body-small" style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      color: 'var(--text-muted)'
                    }}>
                      <Calendar size={14} />
                      {new Date(article.date).toLocaleDateString('fr-FR', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                      })}
                    </span>
                  </div>
                  <h3 className="heading-3" style={{ marginBottom: '1rem' }}>
                    {article.title}
                  </h3>
                  <p className="body-medium" style={{ marginBottom: '1.5rem', color: 'var(--text-secondary)' }}>
                    {article.excerpt}
                  </p>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    color: 'var(--accent-primary)',
                    fontWeight: 500
                  }}>
                    <span>Lire l'article</span>
                    <ArrowRight size={18} />
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <style>{`
            .blog-card:hover {
              transform: translateY(-6px);
              box-shadow: 0 12px 32px rgba(0,0,0,0.1);
            }
            .blog-card:hover .blog-image {
              transform: scale(1.05);
            }
          `}</style>
        </div>
      </section>

      <section style={{ background: 'var(--accent-primary)', color: 'white', padding: '5rem 0' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="heading-1" style={{ color: 'white', marginBottom: '1rem' }}>
            Besoin de conseils personnalisés ?
          </h2>
          <p className="body-large" style={{ color: 'white', opacity: 0.95, maxWidth: '600px', margin: '0 auto 2.5rem' }}>
            Prenez rendez-vous pour un accompagnement nutritionnel adapté à votre situation
          </p>
          <a
            href="https://www.onedoc.ch/fr/cabinet-de-groupe/vevey/ebdj4/nutri-centre-riviera"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            style={{ background: 'white', color: 'var(--accent-primary)', textDecoration: 'none' }}
          >
            Prendre rendez-vous
            <ArrowRight size={20} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default Blog;
